import { SummaryDetailCard } from '@framework/ui/components/summary/SummaryDetailCard.tsx';
import { SummaryTextLabel } from '@framework/ui/components/summary/SummaryTextLabel.tsx';
import { SummaryTextValue } from '@framework/ui/components/summary/SummaryTextValue.tsx';
import { Flex, Space } from 'antd';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { type IPersonalDataItem } from './getPersonalDataItems.ts';
import { PersonRoleTag } from './PersonRoleTag.tsx';
import { PersonTypeTag } from './PersonTypeTag.tsx';

const NameWrapper = styled.div`
  font-weight: 600;
  color: ${props => props.theme.colorText};
  font-size: ${props => props.theme.fontSizeHeading4}px;
  padding: 6px 0;
`;

const CodeText = styled.div`
  font-weight: 400;
  font-family: ${props => props.theme.fontFamilyCode};
  color: ${props => props.theme.colorText};
  font-size: ${props => props.theme.fontSize}px;
`;

export interface ISummaryPersonalDataItemProps {
  item: IPersonalDataItem;
}

/** Card del riepilogo dati anagrafici: mostra ruolo, tipo persona, nome, codice fiscale/P.IVA, email e PEC */
export function SummaryPersonalDataItem(props: ISummaryPersonalDataItemProps) {
  const { name, code, email, pec, role: tag, subjectType, type } = props.item;
  const { t } = useTranslation();

  return (
    <SummaryDetailCard fullHeight>
      <Flex vertical gap={6}>
        <Space size={2}>
          <PersonRoleTag role={tag} subjectType={subjectType} />
          <PersonTypeTag type={type} />
        </Space>
        <NameWrapper>{name}</NameWrapper>
        <Flex wrap="wrap" justify="space-between">
          <SummaryTextLabel>
            {t('submission-summary.cf-piva', 'C.F. / P. IVA')}
          </SummaryTextLabel>
          <CodeText>{code}</CodeText>
        </Flex>
        {email && (
          <Flex wrap="wrap" justify="space-between">
            <SummaryTextLabel>
              {t('submission-summary.email', 'Email')}
            </SummaryTextLabel>
            <SummaryTextValue>
              <a
                href={`mailto:${email}`}
                aria-label={t(
                  'submission-summary.email-aria',
                  'Invia email a {{email}}',
                  { email },
                )}
              >
                {email}
              </a>
            </SummaryTextValue>
          </Flex>
        )}
        {pec && (
          <Flex wrap="wrap" justify="space-between">
            <SummaryTextLabel>
              {t('submission-summary.pec', 'PEC')}
            </SummaryTextLabel>
            <SummaryTextValue>
              <a
                href={`mailto:${pec}`}
                aria-label={t(
                  'submission-summary.pec-aria',
                  'Invia PEC a {{pec}}',
                  { pec },
                )}
              >
                {pec}
              </a>
            </SummaryTextValue>
          </Flex>
        )}
      </Flex>
    </SummaryDetailCard>
  );
}
